import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import styled from "styled-components";
import { stringify, parse } from "query-string";
import { TabList, Tab } from "sprout-ui-dom/dist/Tabs";
import { useActionRegistryGlobalHandler } from "@sprout/list-navigation";
const TopicPageTabsTabList = styled(TabList)`
  padding: 0 16px 20px;
  height: auto;
  justify-content: center;
`;
const TopicPageTabs = ()=>{
    const history = useHistory();
    const { search  } = useLocation();
    const { q  } = parse(search);
    const initialIndex = typeof q === "string" && q.toLowerCase() === "sections" ? 1 : 0;
    const [index, setIndex] = useState(initialIndex);
    const handleChange = useCallback((_, nextIndex)=>{
        if (index === nextIndex) return;
        setIndex(nextIndex);
        history.replace({
            search: stringify({
                q: nextIndex === 0 ? "leaves" : "sections"
            })
        });
    }, [
        index,
        history
    ]);
    useActionRegistryGlobalHandler("PREVIOUS", useCallback(()=>{
        handleChange(null, 0);
        return true;
    }, [
        handleChange
    ]));
    useActionRegistryGlobalHandler("NEXT", useCallback(()=>{
        handleChange(null, 1);
        return true;
    }, [
        handleChange
    ]));
    return /*#__PURE__*/ _jsxs(TopicPageTabsTabList, {
        index: index,
        onChange: handleChange,
        children: [
            /*#__PURE__*/ _jsx(Tab, {
                children: "Leaves"
            }),
            /*#__PURE__*/ _jsx(Tab, {
                children: "Branches"
            })
        ]
    });
};
export default TopicPageTabs;
